var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-tree-panel',{ref:"zcs",staticStyle:{"width":"400px !important","height":"100%"},attrs:{"data":_vm.coordinatedData,"treeWidth":_vm.treeWidth},on:{"selected":_vm.onSelect}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }